import React, { FunctionComponent, SVGProps } from 'react';
import { ParagraphFieldSC } from './paragraph-field.styled';

type ParagraphFieldProps = {
  paragraph: string;
  icon: string | FunctionComponent<SVGProps<SVGSVGElement>>;
};

const ParagraphField: React.FunctionComponent<ParagraphFieldProps> = ({ paragraph, icon }) => {
  return (
    <ParagraphFieldSC>
      <img src={icon as string} />
      <span>{paragraph}</span>
    </ParagraphFieldSC>
  );
};

export default React.memo(ParagraphField);
